import DashboardWrapper from '../../layout/DashboardWrapper';
import VideoPlayer from '../../components/sections/VideoPlayer';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Avatar, AvatarFallback, AvatarImage } from '../../components/ui/avatar';
// import { Download, FileText } from "lucide-react";

const chatNotes = [
    {
        id: 1,
        user: 'Jane Doe',
        avatar: 'https://picsum.photos/200',
        message:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry&apos;s standard dummy text ever since the 1500s',
    },
    {
        id: 2,
        user: 'Jane Doe',
        avatar: 'https://picsum.photos/200',
        message:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry&apos;s standard dummy text ever since the 1500s',
    },
    {
        id: 3,
        user: 'Xavier Ronald',
        avatar: 'https://picsum.photos/200',
        message:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry&apos;s standard dummy text ever since the 1500s',
    },
    {
        id: 4,
        user: 'King Charles',
        avatar: 'https://picsum.photos/200',
        message:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry&apos;s standard dummy text ever since the 1500s',
    },
];

const ViewRecording = () => {
    return (
        <DashboardWrapper>
            <div className="max-w-5xl mx-auto">
                <h1 className="">24A Python Programming Class</h1>
                <p className="text-neutral-500 text-sm">
                    Held on Thursday Jun 14 &bull; From 7:00pm to 9:00pm &bull; By John Doe
                </p>
                <VideoPlayer
                    options={{
                        controls: true,
                        fluid: true,
                        autoplay: false,
                        preload: 'auto',
                        playbackRates: [0.5, 1, 1.5, 2],
                        sources: [
                            {
                                src: 'https://www.youtube.com/watch?v=KABJL5OavL4',
                                type: 'video/youtube',
                            },
                        ],
                        youtube: {
                            iv_load_policy: 3, // Disable annotations
                            modestbranding: 1, // Minimal YouTube branding
                            rel: 0, // Disable related videos at the end // Hide video title and uploader
                            controls: 0, // Show player controls
                            playsinline: 1, // Play inline on mobile devices
                            showinfo: 0, // Hide video title and uploader
                        },
                    }}
                />
                <Tabs defaultValue="notes" className="w-full my-3">
                    <TabsList>
                        <TabsTrigger value="notes">Notes</TabsTrigger>
                        <TabsTrigger value="transcript">Transcript</TabsTrigger>
                    </TabsList>
                    <TabsContent value="notes">
                        <h3>Notes from Meeting Chat</h3>
                        <div className="flex flex-col mt-3 gap-2">
                            {chatNotes.map(note => (
                                <div key={note.id} className="flex gap-3">
                                    <Avatar className="h-10 w-10 shrink-0">
                                        <AvatarImage src={note.avatar || '/placeholder.svg'} />
                                        <AvatarFallback>
                                            {note.user
                                                .split(' ')
                                                .map(word => word[0])
                                                .join('')}
                                        </AvatarFallback>
                                    </Avatar>
                                    <div className="">
                                        <div className="font-medium mb-1 text-neutral-700-secondary">
                                            {note.user}
                                        </div>
                                        <p className="text-sm bg-neutral-200 rounded-lg p-2 leading-relaxed text-neutral-700">
                                            {note.message}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </TabsContent>
                    <TabsContent value="transcript">
                        <h3>Autogenerated Video Transcript</h3>
                        <div className="flex flex-col gap-4 mt-3 font-body">
                            <div className="flex flex-col">
                                <div className="text-sm font-medium text-neutral-500 w-12 shrink-0">
                                    0:00
                                </div>
                                <p className="text-neutral-700 text-sm leading-relaxed">
                                    Lorem Ipsum is simply dummy text of the printing and typesetting
                                    industry. Lorem Ipsum has been the industrys standard dummy text
                                    ever since the 1500s, when an unknown printer took a galley of
                                    type and scrambled it to make a type specimen book
                                </p>
                            </div>

                            <div className="flex flex-col">
                                <div className="text-sm font-medium text-neutral-500 w-12 shrink-0">
                                    0:10
                                </div>
                                <p className="text-neutral-700 text-sm leading-relaxed">
                                    Lorem Ipsum is simply dummy text of the printing and typesetting
                                    industry. Lorem Ipsum has been the industry&apos;s standard
                                    dummy text ever since the 1500s, when an unknown printer took a
                                    galley of type and scrambled it to make a type specimen book
                                </p>
                            </div>

                            <div className="flex flex-col">
                                <div className="text-sm font-medium text-neutral-500 w-12 shrink-0">
                                    0:20
                                </div>
                                <p className="text-neutral-700 text-sm leading-relaxed">
                                    Lorem Ipsum is simply dummy text of the printing and typesetting
                                    industry. Lorem Ipsum has been the industry&apos;s standard
                                    dummy text ever since the 1500s, when an unknown printer took a
                                    galley of type and scrambled it to make a type specimen book
                                </p>
                            </div>

                            <div className="flex flex-col">
                                <div className="text-sm font-medium text-neutral-500 w-12 shrink-0">
                                    0:30
                                </div>
                                <p className="text-neutral-700 text-sm leading-relaxed">
                                    Lorem Ipsum is simply dummy text of the printing and typesetting
                                    industry. Lorem Ipsum has been the industry&apos;s standard
                                    dummy text ever since the 1500s, when an unknown printer took a
                                    galley of type and scrambled it to make a type specimen book
                                </p>
                            </div>
                        </div>
                    </TabsContent>
                </Tabs>
            </div>
        </DashboardWrapper>
    );
};

export default ViewRecording;
